<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>handyman</mat-icon> Material erfassen
</h2>

<mat-dialog-content class="me-content">
  <div class="me-context sk-muted" *ngIf="data.einsatzLabel">
    <mat-icon class="sk-inline-icon">event</mat-icon> {{data.einsatzLabel}}
  </div>

  <div class="me-offline-hint" *ngIf="useQueueOffline">
    <mat-icon>cloud_off</mat-icon>
    <span>Offline – das Material wird lokal gespeichert und automatisch nachgesendet.</span>
  </div>

  <p class="sk-muted me-hint" *ngIf="materials.length === 0">
    Noch kein Material erfasst. Füge hinzu, was auf der Baustelle verbraucht wurde.
  </p>

  <div class="material-row" *ngFor="let m of materials; let i = index">
    <mat-form-field appearance="outline" class="material-name">
      <mat-label>Material</mat-label>
      <input matInput [(ngModel)]="m.name" placeholder="z.B. Schalung">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-qty">
      <mat-label>Menge</mat-label>
      <input matInput type="number" min="0" step="0.5" [(ngModel)]="m.quantity">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-unit">
      <mat-label>Einheit</mat-label>
      <mat-select [(ngModel)]="m.unit">
        <mat-option value="Stk">Stk</mat-option>
        <mat-option value="m">m</mat-option>
        <mat-option value="m²">m²</mat-option>
        <mat-option value="m³">m³</mat-option>
        <mat-option value="kg">kg</mat-option>
        <mat-option value="t">t</mat-option>
        <mat-option value="l">l</mat-option>
        <mat-option value="Pal">Pal</mat-option>
        <mat-option value="Pkg">Pkg</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="removeMaterial(i)" matTooltip="Entfernen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <button mat-stroked-button class="add-material" (click)="addMaterial()">
    <mat-icon>add</mat-icon> Material hinzufügen
  </button>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
    <mat-icon *ngIf="!saving">check</mat-icon>
    {{ useQueueOffline ? 'Offline speichern' : 'Speichern' }}
  </button>
</mat-dialog-actions>
